/**
 * @generated SignedSource<<d991c4765c6e169aff068e778bde07c3>>
 * @relayHash d1647404bf640eabc16cdb8aab372243
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d1647404bf640eabc16cdb8aab372243

import { ConcreteRequest } from 'relay-runtime';
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type de_BetterDocBodyRegion = "BLOOD_AND_BLOOD_CANCER" | "BONES_JOINTS_AND_MUSCULOSKELETAL_SYSTEM" | "BRAIN_NERVES_AND_CHRONIC_PAIN" | "CHILDREN_AND_ADOLESCENTS" | "DIGESTIVE_ORGANS" | "EAR_NOSE_AND_THROAT" | "EYES" | "HEART_AND_BLOOD_VESSELS" | "HORMONES_AND_METABOLISM" | "LUNGS_AND_AIRWAYS" | "MENTAL_HEALTH" | "PLASTIC_AND_AESTHETIC_SURGERY" | "PROSTATE" | "REPRODUCTIVE_ORGANS_AND_FERTILITY" | "RHEUMATIC_DISEASES" | "SKIN_AND_RECONSTRUCTIVE_SURGERY" | "TEETH_AND_JAW" | "URINARY_TRACT_AND_KIDNEYS";
export type de_BetterDocChildAndAdolescentCheckUp = "DAYS_3_TO_10" | "MONTHS_10_TO_12" | "MONTHS_21_TO_24" | "MONTHS_34_TO_36" | "MONTHS_3_TO_4" | "MONTHS_46_TO_48" | "MONTHS_60_TO_64" | "MONTHS_6_TO_7" | "NEWBORN_FIRST_EXAMINATION" | "WEEKS_4_TO_5" | "YEARS_12_TO_14" | "YEARS_16_TO_17";
export type de_BetterDocConsultationReason = "FIRST_SPECIALIST_CONSULTATION" | "GENERAL_PRACTITIONER" | "PSYCHOTHERAPIST_PSYCHIATRIST" | "SECOND_OPINION" | "SPECIALIST_DIAGNOSTIC_PROCEDURE" | "SPECIALIST_PREVENTIVE_CARE" | "SURGEON_WANTED";
export type de_BetterDocExcludingDiagnosis = "ANAL_ABSCESS" | "ANAL_FISSURE" | "ANAL_FISTULA" | "CORONARY_HEART_DISEASE" | "CROHNS_DISEASE" | "EPILEPSY" | "FAECAL_INCONTINENCE" | "GALLSTONES" | "HAEMORRHOIDS" | "HIGH_BLOOD_PRESSURE" | "IMPAIRED_WOUND_HEALING" | "MIGRAINE_CHRONIC_HEADACHE" | "MULTIPLE_SCLEROSIS" | "OTHER_COMPLAINTS_IN_BUTTOCK_OR_ANAL_AREA" | "PILONIDAL_SINUS" | "PROSTATE_CANCER_SUSPECTED_OR_CONFIRMED" | "RECTAL_PROLAPSE" | "RECTAL_PROLAPSE_LAY_TERM" | "SUSPECTED_COLORECTAL_CANCER" | "ULCERATIVE_COLITIS" | "URETHRAL_STRICTURE" | "VARICOSE_VEINS";
export type de_BetterDocPreventiveCareScreening = "ANEURYSM_SCREENING_ABDOMINAL_AORTA" | "ANTENATAL_CARE" | "BREAST_CANCER_SCREENING" | "CANCER_SCREENING_FOR_MEN" | "CANCER_SCREENING_FOR_WOMEN" | "CHILD_AND_ADOLESCENT_CHECK_UPS" | "CHLAMYDIA_SCREENING" | "COLORECTAL_CANCER_SCREENING" | "DENTAL_CHECK_UP" | "GENERAL_HEALTH_CHECK_UP" | "SKIN_CANCER_SCREENING" | "TRAVEL_HEALTH_ADVICE_VACCINATIONS";
export type de_BetterDocPreviousDoctor = "GENERAL_PRACTITIONER" | "NONE" | "SPECIALIST";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocSpecificExamination = "ALLERGY_TEST" | "BONE_SCINTIGRAPHY" | "COLONOSCOPY" | "CT_SCAN" | "DUPLEX_ULTRASOUND" | "DXA_BONE_DENSITY_SCAN" | "ECHOCARDIOGRAPHY" | "EXERCISE_ECG" | "GASTROSCOPY" | "GASTROSCOPY_AND_COLONOSCOPY" | "HEARING_TEST" | "HOLTER_ECG" | "LUNG_FUNCTION_TEST" | "MRI_SCAN" | "ORTHOPTICS_EYE_TEST" | "POLYGRAPHY_SLEEP_STUDY" | "PROCTOLOGICAL_EXAMINATION" | "RESTING_ECG" | "THYROID_SCINTIGRAPHY" | "TWENTY_FOUR_HOUR_BLOOD_PRESSURE_MONITORING" | "ULTRASOUND" | "VENOUS_DIAGNOSTICS" | "X_RAY";
export type de_BetterDocSymptomLocation = "ELBOW" | "FOOT_AND_ANKLE" | "HAND_AND_WRIST" | "HIP" | "KNEE" | "SHOULDER" | "SPINE_AND_BACK";
export type de_RequestBetterDocRecommendationOutcome = "EXISTING_RECOMMENDATION" | "MSN_PENDING" | "NO_NAVIGATION" | "PMN_RECEIVED";
export type De_requestBetterDocRecommendationInput = {
  address: AddressInput;
  answers: BetterDocConsultationAnswersInput;
  effectivePointOfCare: PointOfCareType;
  insurance: BetterDocRecommendationInsuranceInput;
  phoneNumber: string;
  pointOfCareSpecialtyId?: string | null;
  preferredMedicActivityId?: number | null;
  progressNoteId: string;
  subSpecialty?: string | null;
};
export type AddressInput = {
  city: string;
  countryCode: string;
  houseNumberStreet: string;
  postalCode: string;
};
export type BetterDocConsultationAnswersInput = {
  allergiesToTest?: string | null;
  bodyPartToExamine?: string | null;
  bodyRegion?: de_BetterDocBodyRegion | null;
  childAndAdolescentCheckUpDetails?: de_BetterDocChildAndAdolescentCheckUp | null;
  excludingDiagnosis?: de_BetterDocExcludingDiagnosis | null;
  magneticResonanceImagingDone?: boolean | null;
  preventiveCareScreening?: de_BetterDocPreventiveCareScreening | null;
  previousDoctor?: de_BetterDocPreviousDoctor | null;
  reasonForConsultation: de_BetterDocConsultationReason;
  specificExamination?: de_BetterDocSpecificExamination | null;
  symptomLocation?: de_BetterDocSymptomLocation | null;
  symptomsLongerThanOneMonth?: boolean | null;
};
export type BetterDocRecommendationInsuranceInput = {
  insureeNumber: string;
  insurerKey: string;
  productBetterDocKey: string;
};
export type useRequestBetterDocRecommendationMutation$variables = {
  input: De_requestBetterDocRecommendationInput;
};
export type useRequestBetterDocRecommendationMutation$data = {
  readonly requestBetterDocRecommendation: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly requestBetterDocRecommendationResult: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly outcome: de_RequestBetterDocRecommendationOutcome;
      readonly sessionId: number;
    } | null;
  };
};
export type useRequestBetterDocRecommendationMutation = {
  response: useRequestBetterDocRecommendationMutation$data;
  variables: useRequestBetterDocRecommendationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "requestBetterDocRecommendationResult",
  "args": null,
  "concreteType": "de_RequestBetterDocRecommendationResult",
  "kind": "LinkedField",
  "name": "de_RequestBetterDocRecommendationResult",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outcome",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "betterDocState",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRequestBetterDocRecommendationMutation",
    "selections": [
      {
        "alias": "requestBetterDocRecommendation",
        "args": (v1/*:: as any*/),
        "concreteType": "De_requestBetterDocRecommendationPayload",
        "kind": "LinkedField",
        "name": "de_requestBetterDocRecommendation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRequestBetterDocRecommendationMutation",
    "selections": [
      {
        "alias": "requestBetterDocRecommendation",
        "args": (v1/*:: as any*/),
        "concreteType": "De_requestBetterDocRecommendationPayload",
        "kind": "LinkedField",
        "name": "de_requestBetterDocRecommendation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d1647404bf640eabc16cdb8aab372243",
    "metadata": {},
    "name": "useRequestBetterDocRecommendationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "22649084c1e5bfe54cce087115238ea5";

export default node;
